<template>
  <form class="form" method="post">

    <div id="appTarifsChoiceVueComponent">
      <HeaderApp />
      <div class="appTarifCardCreate">
        <h2>Mes Tarifs</h2>
        <div>
          <button @click.prevent="createTarif()" type="submit" class="appButtonModel2">Ajouter un nouveau tarif</button>
        </div>

        <h3 class="appTarifH3Style">Femmes</h3>
        <div class="appGroupOfDivNamesAndInput2">
          <div class="appGroupOfDivNames2">
            <p class="appLabelStyle2"></p>
            <p class="appLabelStyle2"></p>
            <p class="appLabelStyle2">S</p>
            <p class="appLabelStyle2">M</p>
            <p class="appLabelStyle2">L</p>
            <p class="appLabelStyle2">XL</p>
          </div>
          <div :key="'tarifFiltersWomen' + index" v-for="(tarifFiltersWomen, index) in tarifFiltersWomens">
            <p @click.prevent="editTarif(tarifFiltersWomen._id)" type="submit" class="appLabelStyle3 appHoverEffect2">
              {{ tarifFiltersWomen.name }}</p>
            <div class="appGroupOfInput2">
              <p class="appLabelStyle2"></p>
              <vue-numeric currency="€" currency-symbol-position="suffix" v-bind:precision="2"
                v-model="tarifFiltersWomen.priceUnique" type="string" name="priceUnique" class="appLabelStyle2"
                disabled="disabled"></vue-numeric>
              <vue-numeric currency="€" currency-symbol-position="suffix" v-bind:precision="2"
                v-model="tarifFiltersWomen.priceS" type="string" name="priceS" class="appLabelStyle2"
                disabled="disabled"></vue-numeric>
              <vue-numeric currency="€" currency-symbol-position="suffix" v-bind:precision="2"
                v-model="tarifFiltersWomen.priceM" type="string" name="priceM" class="appLabelStyle2"
                disabled="disabled"></vue-numeric>
              <vue-numeric currency="€" currency-symbol-position="suffix" v-bind:precision="2"
                v-model="tarifFiltersWomen.priceL" type="string" name="priceL" class="appLabelStyle2"
                disabled="disabled"></vue-numeric>
              <vue-numeric currency="€" currency-symbol-position="suffix" v-bind:precision="2"
                v-model="tarifFiltersWomen.priceXL" type="string" name="priceXL" class="appLabelStyle2"
                disabled="disabled"></vue-numeric>
            </div>
          </div>
        </div>

        <h3 class="appTarifH3Style">Suppléments</h3>
        <div class="appGroupOfDivNamesAndInput2">
          <div class="appGroupOfDivNames2">
            <p class="appLabelStyle2"></p>
            <p class="appLabelStyle2"></p>
            <p class="appLabelStyle2">S</p>
            <p class="appLabelStyle2">M</p>
            <p class="appLabelStyle2">L</p>
            <p class="appLabelStyle2">XL</p>
          </div>
          <div :key="'tarifFiltersSupplements' + index" v-for="(tarifFiltersSupplements, index) in tarifFiltersSupplements">
            <p @click.prevent="editTarif(tarifFiltersSupplements._id)" type="submit" class="appLabelStyle3 appHoverEffect2">
              {{ tarifFiltersSupplements.name }}</p>
            <div class="appGroupOfInput2">
              <p class="appLabelStyle2"></p>
              <vue-numeric currency="€" currency-symbol-position="suffix" v-bind:precision="2"
                v-model="tarifFiltersSupplements.priceUnique" type="string" name="priceUnique" class="appLabelStyle2"
                disabled="disabled"></vue-numeric>
              <vue-numeric currency="€" currency-symbol-position="suffix" v-bind:precision="2"
                v-model="tarifFiltersSupplements.priceS" type="string" name="priceS" class="appLabelStyle2"
                disabled="disabled"></vue-numeric>
              <vue-numeric currency="€" currency-symbol-position="suffix" v-bind:precision="2"
                v-model="tarifFiltersSupplements.priceM" type="string" name="priceM" class="appLabelStyle2"
                disabled="disabled"></vue-numeric>
              <vue-numeric currency="€" currency-symbol-position="suffix" v-bind:precision="2"
                v-model="tarifFiltersSupplements.priceL" type="string" name="priceL" class="appLabelStyle2"
                disabled="disabled"></vue-numeric>
              <vue-numeric currency="€" currency-symbol-position="suffix" v-bind:precision="2"
                v-model="tarifFiltersSupplements.priceXL" type="string" name="priceXL" class="appLabelStyle2"
                disabled="disabled"></vue-numeric>
            </div>
          </div>
        </div>

        <h3 class="appTarifH3Style">Cérémonie</h3>
        <div class="appGroupOfDivNamesAndInput2">
          <div class="appGroupOfDivNames2">
            <p class="appLabelStyle2"></p>
            <p class="appLabelStyle2"></p>
            <p class="appLabelStyle2"></p>
            <p class="appLabelStyle2"></p>
            <p class="appLabelStyle2"></p>
            <p class="appLabelStyle2"></p>
          </div>
          <div :key="'tarifFiltersCeremonie' + index" v-for="(tarifFiltersCeremonie, index) in tarifFiltersCeremonie">
            <p @click.prevent="editTarif(tarifFiltersCeremonie._id)" type="submit" class="appLabelStyle3 appHoverEffect2">
              {{ tarifFiltersCeremonie.name }}</p>
            <div class="appGroupOfInput2">
              <p class="appLabelStyle2"></p>
              <vue-numeric currency="€" currency-symbol-position="suffix" v-bind:precision="2"
                v-model="tarifFiltersCeremonie.priceUnique" type="string" name="priceUnique" class="appLabelStyle2"
                disabled="disabled"></vue-numeric>
              <vue-numeric currency="€" currency-symbol-position="suffix" v-bind:precision="2"
                v-model="tarifFiltersCeremonie.priceS" type="string" name="priceS" class="appLabelStyle2"
                disabled="disabled"></vue-numeric>
              <vue-numeric currency="€" currency-symbol-position="suffix" v-bind:precision="2"
                v-model="tarifFiltersCeremonie.priceM" type="string" name="priceM" class="appLabelStyle2"
                disabled="disabled"></vue-numeric>
              <vue-numeric currency="€" currency-symbol-position="suffix" v-bind:precision="2"
                v-model="tarifFiltersCeremonie.priceL" type="string" name="priceL" class="appLabelStyle2"
                disabled="disabled"></vue-numeric>
              <vue-numeric currency="€" currency-symbol-position="suffix" v-bind:precision="2"
                v-model="tarifFiltersCeremonie.priceXL" type="string" name="priceXL" class="appLabelStyle2"
                disabled="disabled"></vue-numeric>
            </div>
          </div>
        </div>

        <h3 class="appTarifH3Style">Hommes</h3>
        <div class="appGroupOfDivNamesAndInput2">
          <div class="appGroupOfDivNames2">
            <p class="appLabelStyle2"></p>
            <p class="appLabelStyle2"></p>
            <p class="appLabelStyle2"></p>
            <p class="appLabelStyle2"></p>
            <p class="appLabelStyle2"></p>
            <p class="appLabelStyle2"></p>
          </div>
          <div :key="'tarifFiltersMen' + index" v-for="(tarifFiltersMen, index) in tarifFiltersMens">
            <p @click.prevent="editTarif(tarifFiltersMen._id)" type="submit" class="appLabelStyle3 appHoverEffect2">
              {{ tarifFiltersMen.name }}</p>
            <div class="appGroupOfInput2">
              <p class="appLabelStyle2"></p>
              <vue-numeric currency="€" currency-symbol-position="suffix" v-bind:precision="2"
                v-model="tarifFiltersMen.priceUnique" type="string" name="priceUnique" class="appLabelStyle2"
                disabled="disabled"></vue-numeric>
              <vue-numeric currency="€" currency-symbol-position="suffix" v-bind:precision="2"
                v-model="tarifFiltersMen.priceS" type="string" name="priceS" class="appLabelStyle2"
                disabled="disabled"></vue-numeric>
              <vue-numeric currency="€" currency-symbol-position="suffix" v-bind:precision="2"
                v-model="tarifFiltersMen.priceM" type="string" name="priceM" class="appLabelStyle2"
                disabled="disabled"></vue-numeric>
              <vue-numeric currency="€" currency-symbol-position="suffix" v-bind:precision="2"
                v-model="tarifFiltersMen.priceL" type="string" name="priceL" class="appLabelStyle2"
                disabled="disabled"></vue-numeric>
              <vue-numeric currency="€" currency-symbol-position="suffix" v-bind:precision="2"
                v-model="tarifFiltersMen.priceXL" type="string" name="priceXL" class="appLabelStyle2"
                disabled="disabled"></vue-numeric>
            </div>
          </div>
        </div>

        <h3 class="appTarifH3Style">Enfants</h3>
        <div class="appGroupOfDivNamesAndInput2">
          <div class="appGroupOfDivNames2">
            <p class="appLabelStyle2"></p>
            <p class="appLabelStyle2"></p>
            <p class="appLabelStyle2">0 à 5 ans</p>
            <p class="appLabelStyle2"></p>
            <p class="appLabelStyle2">6 à 17 ans</p>
            <p class="appLabelStyle2"></p>
          </div>
          <div :key="'tarifFiltersKid' + index" v-for="(tarifFiltersKid, index) in tarifFiltersKids">
            <p @click.prevent="editTarif(tarifFiltersKid._id)" type="submit" class="appLabelStyle3 appHoverEffect2">
              {{ tarifFiltersKid.name }}</p>
            <div class="appGroupOfInput2">
              <p class="appLabelStyle2"></p>
              <vue-numeric currency="€" currency-symbol-position="suffix" v-bind:precision="2"
                v-model="tarifFiltersKid.priceUnique" type="string" name="priceUnique" class="appLabelStyle2"
                disabled="disabled"></vue-numeric>
              <vue-numeric currency="€" currency-symbol-position="suffix" v-bind:precision="2"
                v-model="tarifFiltersKid.priceS" type="string" name="priceS" class="appLabelStyle2"
                disabled="disabled"></vue-numeric>
              <vue-numeric currency="€" currency-symbol-position="suffix" v-bind:precision="2"
                v-model="tarifFiltersKid.priceM" type="string" name="priceM" class="appLabelStyle2"
                disabled="disabled"></vue-numeric>
              <vue-numeric currency="€" currency-symbol-position="suffix" v-bind:precision="2"
                v-model="tarifFiltersKid.priceL" type="string" name="priceL" class="appLabelStyle2"
                disabled="disabled"></vue-numeric>
              <vue-numeric currency="€" currency-symbol-position="suffix" v-bind:precision="2"
                v-model="tarifFiltersKid.priceXL" type="string" name="priceXL" class="appLabelStyle2"
                disabled="disabled"></vue-numeric>
            </div>
          </div>
      </div>

      <h3 class="appTarifH3Style">Soins</h3>
      <div class="appGroupOfDivNamesAndInput2">
        <div class="appGroupOfDivNames2">
          <p class="appLabelStyle2"></p>
          <p class="appLabelStyle2"></p>
          <p class="appLabelStyle2"></p>
          <p class="appLabelStyle2"></p>
          <p class="appLabelStyle2"></p>
          <p class="appLabelStyle2"></p>
        </div>
        <div :key="'tarifFiltersBienEtre'+index" v-for="(tarifFiltersBienEtre, index) in tarifFiltersBienEtre">
          <p @click.prevent="editTarif(tarifFiltersBienEtre._id)" type="submit" class="appLabelStyle3 appHoverEffect2">
            {{tarifFiltersBienEtre.name}}</p>
          <div class="appGroupOfInput2">
            <p class="appLabelStyle2"></p>
            <vue-numeric currency="€" currency-symbol-position="suffix" v-bind:precision="2"
              v-model="tarifFiltersBienEtre.priceUnique" type="string" name="priceUnique" class="appLabelStyle2"
              disabled="disabled"></vue-numeric>
            <vue-numeric currency="€" currency-symbol-position="suffix" v-bind:precision="2"
              v-model="tarifFiltersBienEtre.priceS" type="string" name="priceS" class="appLabelStyle2"
              disabled="disabled"></vue-numeric>
            <vue-numeric currency="€" currency-symbol-position="suffix" v-bind:precision="2"
              v-model="tarifFiltersBienEtre.priceM" type="string" name="priceM" class="appLabelStyle2"
              disabled="disabled"></vue-numeric>
            <vue-numeric currency="€" currency-symbol-position="suffix" v-bind:precision="2"
              v-model="tarifFiltersBienEtre.priceL" type="string" name="priceL" class="appLabelStyle2"
              disabled="disabled"></vue-numeric>
            <vue-numeric currency="€" currency-symbol-position="suffix" v-bind:precision="2"
              v-model="tarifFiltersBienEtre.priceXL" type="string" name="priceXL" class="appLabelStyle2"
              disabled="disabled"></vue-numeric>
          </div>
        </div>
      </div>
      <br>
      <br>
      <br>
    </div>
  </div>

</form>
</template>

<script>
import axios from 'axios'
import VueNumeric from 'vue-numeric'
import HeaderApp from '../Application/HeaderApp.vue'
export default {
  beforeCreate () {
    const tokenWithDatas = JSON.parse(localStorage.getItem('userPrivilegia'))
    if (!tokenWithDatas) { this.$router.push('/App/Login') }
  },
  components: {
    HeaderApp,
    VueNumeric
  },
  name: 'TarifsList',
  data () {
    return {
      tarif: []
    }
  },
  mounted () {
    this.getAllTarifs()
  },
  computed: {
    tarifFiltersWomens () {
      return this.tarif.filter(tarif => tarif.category === 'FEMMES')
    },
    tarifFiltersSupplements () {
      return this.tarif.filter(tarif => tarif.category === 'SUPPLÉMENTS')
    },
    tarifFiltersCeremonie () {
      return this.tarif.filter(tarif => tarif.category === 'CÉRÉMONIE')
    },
    tarifFiltersMens () {
      return this.tarif.filter(tarif => tarif.category === 'HOMMES')
    },
    tarifFiltersKids () {
      return this.tarif.filter(tarif => tarif.category === 'ENFANTS')
    },
    tarifFiltersBienEtre () {
      return this.tarif.filter(tarif => tarif.category === 'SOINS')
    }
  },
  methods: {
    getAllTarifs () {
      const tokenWithDatas = JSON.parse(localStorage.getItem('userPrivilegia'))
      axios
        .get(('https://privilegia.fr/api/tarifs'), { headers: { Authorization: 'Bearer ' + tokenWithDatas.token } })
        .then((response) => {
          this.tarif = response.data.sort(function tri (a, b) {
            if (a.name < b.name) { return -1 }
            if (a.name === b.name) { return 0 }
            if (a.name > b.name) { return 1 }
          })
        })
    },
    createTarif () {
      this.$router.push('/App/Tarifs/Create')
    },
    editTarif (id) {
      this.$router.push('/App/Tarifs/Edit?id=' + id)
    }
  }
}
</script>
<style>
</style>



// WEBPACK FOOTER //
// src/components/Application/AppTarifsChoice.vue